/* eslint-disable kf/const-naming-convention */
export const PLAN = {
  STARTER: "Starter",
  GROWING: "Growing",
  ENTERPRISE: "Enterprise",
  FULLYLOADED: "Fully Loaded"
};

export const ACCOUNT_STATUS = {
  TRIAL: "Trial",
  NFR: "NFR",
  ACTIVE: "Active"
};

export const USER_TYPES = {
  USER: 0,
  BILLING_ADMIN: 1,
  USER_ADMIN: 2,
  SUPER_ADMIN: 3
};

export const ACCOUNT_TYPES = {
  STANDARD_ACCOUNT: 0,
  DEVELOPMENT_ACCOUNT: 10,
  PRINCIPAL_ACCOUNT: 20,
  SUPER_ACCOUNT: 50,
  SYSTEM_ACCOUNT: 90
};

export const ROLES = {
  SUPER_ADMIN: "Super Admin",
  USER_ADMIN: "User Admin",
  BILLING_ADMIN: "Billing Admin",
  USER: "User"
};

export const PRODUCT_TYPES = {
  KF_PROCESS: "KF PROCESS",
  KF_PROJECT: "KF PROJECT",
  KF_WORKFLOW_LITE: "KF WORKFLOW LITE",
  KF_WORKFLOW: "KF WORKFLOW",
  KF_COMMUNITY: "KF COMMUNITY",
  KF_DW: "KFDW",
  KF_WORKFLOW_SUITE: "KF WORKFLOW SUITE",
  KF_LOWCODE: "KF LOWCODE",
  KF_KPC: "KPC",
  KF_WORKPLATFORM: "KF WORKPLATFORM",
  KF_DEV_WORKPLATFORM: "KF DEV WORKPLATFORM",
  KF_TEST_WORKPLATFORM: "KF TEST WORKPLATFORM"
};

export const PRODUCTS = {
  PROCESS: "Process",
  DATASET: "Dataset",
  PROJECT: "Project",
  CASE: "Case",
  INTEGRATION: "Integration",
  CHAT: "Chat",
  TEAM: "Team",
  CHANNEL: "Channel",
  LIST: "List",
  APPLICATION: "Application",
  PORTAL: "Portal",
  ANALYTICS: "Analytics"
};

export const AccountErrors = {
  TrialExpired: "TrialExpired",
  DunningExpired: "DunningExpired"
};

export const BillingEvents = {
  LISTEN_SUBSCRIPTION_CARD: "listenSubscriptionCard",
  REMOVE_SUBSCRIPTION_CARD_LISTENER: "removeSubscriptionListener"
};

export const USER_KIND = {
  USER: "User",
  GROUP: "Group",
  ROLE: "Role",
  SERVICE_ACCOUNT: "ServiceAccount"
};

export const USER_POPUP_OPTIONS = {
  MESSAGE: "message",
  PROFILE: "profile"
};

export const ENVIRONMENT_TYPES = {
  DEVELOPMENT: "Development",
  TEST: "Test",
  PRODUCTION: "Production"
};
